<nav class="navbar navbar-expand fixed-top px-3"
  style="padding:5px; box-shadow: 0 1px 1px 0px #ddd; background-color: #fff;">
  <button type="button" class="btn btn-apportis-outline-primary-theme mr-3" (click)="onToggleSidebar()">
    <i class="fas fa-bars"></i>
  </button>
  <div class="navbar-brand mr-auto" style="padding-top: 0.2rem; padding-bottom: .2rem;max-width:180px;height:54px;">

    <img *ngIf="role == 'System Admin'" src="../../assets/apportis-new-logo.png" alt="logo-dark"
      style="max-width: 100%;max-height: 100%;">
    <img *ngIf="role != 'System Admin'" src={{orgLogoImageUrl}} alt="logo-dark"
      style="max-width: 100%;max-height: 100%;">
  </div>

  <button class="navbar-toggler btn" type="button" data-toggle="collapse" data-target="#topMenuContent"
    aria-controls="topMenuContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div id="topMenuContent" class="navbar-collapse collapse">

    <div class="ml-auto">
      <label class="text-color covid-info"
        *ngIf="(secondShotDetailsavailable && (role == 'Patient' || role == 'Participant')) ">{{'NextCOVIDVaccinationon'
        | translateOrgSpecific}} {{secondShotdate}}
      </label>
      <button [disabled]="isHelpNowRequested"
        *ngIf="role == PatientLabel && !is_hospital_organisation && profileImageUrl && !is_university "
        class="btn btn-apportis-primary-theme btn-block help-now-btn" (click)="helpNow()">
        <span>{{'HelpNow' | translateOrgSpecific}}</span>
        <span *ngIf="isHelpNowRequested" style="padding-left:2px;">
          <i class="fas fa-spinner fa-spin"></i>
        </span> </button>
      <button [disabled]="isHelpNowRequested"
        *ngIf="role == PatientLabel && !is_hospital_organisation && !profileImageUrl && !is_university "
        class="btn btn-apportis-primary-theme btn-block help-now-btn-no-img" (click)="helpNow()">
        <span>{{'HelpNow' | translateOrgSpecific}}</span>
        <span *ngIf="isHelpNowRequested" style="padding-left:2px;">
          <i class="fas fa-spinner fa-spin"></i>
        </span> </button>

      <button [ngClass]="{'donate-btn':profileImageUrl &&( is_count_available || waitingRoomlevel == 'Clinician'),'donate-btn-not-img':!profileImageUrl &&( is_count_available || waitingRoomlevel == 'Clinician'),'donate-btn-not-count': (profileImageUrl || !profileImageUrl) &&( !is_count_available && waitingRoomlevel != 'Clinician' )}"
        *ngIf="isEnableDonation && (role == 'Patient' || role ==  PatientLabel || role == ClinicianLabel  || role == 'Family' || role == 'Staff' || role == 'Social Worker')"
        class="btn btn-sm btn-apportis-tertiary " type="submit" (click)="onDonate()">{{ 'Donate' | translateOrgSpecific
        }}</button>

        <label *ngIf="(is_count_available &&  (role == ClinicianLabel || role =='Social Worker'))" style="padding-right: 60px;">
          {{'QueueSize' | translateOrgSpecific}} :
          {{count}}</label>

      <mat-slide-toggle class="topMenuToggle" (change)="emergencyChanged()"
        *ngIf="((role == ClinicianLabel || role == 'Social Worker') && !is_CaseManagement &&((waitingRoomlevel == 'Clinician' && !is_criticalResponse) || is_criticalResponse) ) "
        [(ngModel)]="isReadyForEmergency" style="margin-left:0px;" [checked]="false">
        <span *ngIf="!isReadyForEmergency "
          style="font-size:14px; display: inline-block; width: 90px; text-align: center;">{{'NotAvailable' |
          translateOrgSpecific}}</span>
        <span *ngIf="isReadyForEmergency "
          style="font-size:14px; display: inline-block; width: 90px; text-align: center;">{{'Available' |
          translateOrgSpecific}}</span>
      </mat-slide-toggle>


      <ul class="navbar-nav ml-auto" style="display: inline-block;">
        <li class="nav-item dropdown ml-auto">
          <a class="nav-link dropdown-toggle ml-auto" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
            (click)="onClickProfileMenu()" aria-haspopup="true" aria-expanded="false" style="padding-right: 0px !important">
            <img *ngIf="profileImageUrl" style="height:35px;border-radius: 16px;width: 35px;vertical-align: top;"
              class="img-circle" [src]="profileImageUrl">
            <i *ngIf="!profileImageUrl" class="fas fa-user-circle img-circle "
              style="font-size:20px;vertical-align: super;"></i>
            <div class="d-none d-md-inline-block" style="display: inline-block;margin-left: 10px;">
              <div style="line-height: 1;"> {{username}}</div>
              <div style="line-height: 1.5;font-size: 12px;">{{role | translateOrgSpecific }}</div>

            </div>
          </a>


          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <a routerLink="/app/dashboard" class="dropdown-item">{{'MyDashboard' | translateOrgSpecific}}</a>
            <a *ngIf="!isClinician && !isSocialWorker" routerLink="/app/user/profile"
              class="dropdown-item">{{'MyProfile' |
              translateOrgSpecific}}</a>
            <a *ngIf="isClinician || isSocialWorker" routerLink="/app/user/clinician-profile"
              class="dropdown-item">{{'MyProfile' |
              translateOrgSpecific}}</a>
            <a *ngIf="is_client && is_CaseManagement " routerLink="/app/mylibrary/library"
              class="dropdown-item">{{'MyLibrary' | translateOrgSpecific}}</a>
            <a href="" class="dropdown-item" (click)="switchToSysAdmin();false" *ngIf="isOrgSwitched">{{'ExitOrg' |
              translateOrgSpecific}}</a>
            <!-- <a class="dropdown-item" [autoClose]="true" (click)="popover3.toggle()" *ngIf="allUserRoles.length > 1">
              Switch Role

            </a> -->
            <a (click)="openSwitchRole()" class="dropdown-item" *ngIf="allUserRoles.length > 1" style="cursor: pointer  !important;">

              {{'SwitchRole' | translateOrgSpecific}}
            </a>


            <a routerLink="/signin" class="dropdown-item" (click)="signOut()">{{'SignOut' | translateOrgSpecific}}</a>
          </div>



        </li>
      </ul>
      <!-- <a popoverTitle="Roles" [autoClose]="true" [ngbPopover]="popContent" #popover3="ngbPopover" placement="bottom-right" >
        
      </a> -->
    </div>
  </div>
</nav>

<div *ngIf="showHelp" class="info-popup" style="width:315px;">
  <audio control loop id="audio" src="../../assets/sounds/video-call-alert.wav" autoplay="true"></audio>
  <div style="margin:12px;">
    <div style="margin-left:10px;">
      {{'ClientWaitingInEmergencyRoom' | translateOrgSpecific}}
    </div>
    <div style="margin-top: 10px;margin-left: 10px;">
      <button style="width:100px;display: inline-block;margin-top:0px;" class="btn btn-apportis-primary-theme btn-block"
        (click)="helpNowConfirm()">{{'Confirm' | translateOrgSpecific}}</button>
      <button style="width:100px;display: inline-block;margin-top:0px;margin-left:10px"
        class="btn btn-apportis-primary-theme btn-block" (click)="showHelp = false">{{'Cancel' |
        translateOrgSpecific}}</button>
    </div>
  </div>
</div>
<ng-template #popContent style="z-index: 3500;">
  <div #popContent>
    <div style="width: 180px;">
      <a class="dropdown-item" *ngFor="let obj of allUserRoles" (click)="switchRole(obj)"
        [ngClass]="{'selectedRole':obj.isActive,'defaultRole':obj.isDefault}"
        style="margin-bottom: 3px;">{{obj.role_name}}</a>

    </div>
  </div>
</ng-template>
<app-msg-box #msgbox></app-msg-box>

<!-- //Flyout  -->
<div class="flyout-container" *ngIf="DivisShow">
  <div class="flyout-body dismiss " [style.width.px]="width" style="background-color: #eae9e9;"
    [ngClass]="{'selected' : isShow,'dismiss': !isShow,'bgcolor':isEdit}">
    <div class="flyout-title-container">
      <div *ngIf="!isHideTitle" class="model-title">
        <div class="row">
          <div class="col-md-9">
            <span [ngClass]="{'add-txtcolor':!isEdit}">{{title}}</span>

          </div> 
          <div class="col-md-3" style="text-align: right;">
            <span >
              <i class="fas fa-times closebtn" (click)="closeSwitchRole()" style="font-size: 18px;"></i>
            </span>
          </div> 

        </div>
      </div>

    </div>
    <div class="flyout-content">
      <div>
          <table class="table  table-sm" style="border-bottom: 1px solid #8d8d8d !important; box-shadow: none !important;  ">
                <tbody>
                  <tr style="border-bottom: 2px solid #8d8d8d;font-size: 15px;">
                    <td scope="col">
                      <label class="pr-5">
                       {{'DefaultRole' | translateOrgSpecific}} : </label>  
                        <label style="color: green; font-weight: bold; float: right;">{{defaultRole}}</label>
           
                  </td>
                  </tr>
                  <tr>
                    <td scope="col" style="font-weight: bold;">{{'AllRoles' | translateOrgSpecific}}</td>
                </tr>
                    <tr style="cursor:pointer !important;font-size: 14px !important; "  class="hoverdiv"
                    *ngFor="let obj of allUserRoles ">
                    <td (click)="switchRole(obj)">
                      {{obj.role_name}}
                      <span style="float: right; color: green;" *ngIf="obj.isActive" >
                        <i class="fas fa-circle" style="padding-right: 6px;"></i>
                      </span>
                      
                    </td>
                  </tr>
                </tbody>
                </table>
      </div>
    </div>
  </div>
  <div class="modal-background" *ngIf="isShow"></div>
</div>